import { tags } from './tags';

function endpoints(builder) {
  return {
    getMilestones: builder.query({
      query: ({ participationId, summaryOnly = 0, forceRecheck = 1 }) => `tefaf/exhibitorportal/milestones/get/${participationId}?summaryOnly=${summaryOnly}&forceRecheck=${forceRecheck}`,
      providesTags: tags,
    }),
  };
}

export { endpoints };
